module.exports = __webpack_public_path__ + "img/sonde.695c114e.png";